import React from 'react';
import { classNames } from '@/lib/format';

/** Public paths for HireIQ brand assets under `frontend/public/brand/`. */
export const HIREIQ_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/brand/logo.png`;
export const HIREIQ_MARK_SRC = `${process.env.PUBLIC_URL || ''}/brand/mark.png`;

/**
 * Full wordmark (HireIQ + tagline). Use in headers / login.
 * `xl` is the smallest size where the "the recruitment partner" tagline stays legible.
 * @param {'sm'|'md'|'lg'|'xl'|'sidebar'} [size]
 */
export function HireIqLogo({ size = 'md', className, alt = 'HireIQ', ...rest }) {
  const height =
    size === 'sm' ? 'h-8'
      : size === 'lg' ? 'h-14'
        : size === 'xl' ? 'h-24'
          : size === 'sidebar' ? 'h-[5.5rem]'
            : 'h-10';
  return (
    <img
      src={HIREIQ_LOGO_SRC}
      alt={alt}
      className={classNames('w-auto object-contain object-left', height, className)}
      decoding="async"
      {...rest}
    />
  );
}

/**
 * Compact icon mark (favicon crop). Use in tight chrome / report header.
 * @param {'sm'|'md'|'lg'} [size]
 */
export function HireIqMark({ size = 'md', className, alt = 'HireIQ', ...rest }) {
  const box =
    size === 'sm' ? 'h-8 w-8' : size === 'lg' ? 'h-12 w-12' : 'h-10 w-10';
  return (
    <img
      src={HIREIQ_MARK_SRC}
      alt={alt}
      className={classNames('object-contain', box, className)}
      decoding="async"
      {...rest}
    />
  );
}
